import { render, staticRenderFns } from "./Mensagem.vue?vue&type=template&id=e80620e8"
import script from "./Mensagem.vue?vue&type=script&lang=js"
export * from "./Mensagem.vue?vue&type=script&lang=js"
import style0 from "./Mensagem.vue?vue&type=style&index=0&id=e80620e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports